import { LifeArea } from '@griply/types';

export const isActiveLifeArea = (
  lifeArea: Pick<LifeArea, 'archivedAt' | 'frozenAt'>,
): boolean => !lifeArea.archivedAt && !lifeArea.frozenAt;
